function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import BundleOffers from "../Components/BundleOffers";
import useData from "../data";
import Header from "../Components/Header";
import SkeletonBundleDeals from "../../Common/Skeleton/SkeletonBundleDeals";
import { getFont } from "../../../utils/helpers";
import ZeroState from "../../Common/ZeroState";
import Button from "../../Common/Button";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function BundleDeals(_ref) {
  var _redux$webView$intern, _redux$webView, _config$deals, _redux$auth$isAuthent, _redux$auth;
  var _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    cmsClient = _ref.cmsClient,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    appType = _ref.appType;
  var _useData = useData({
      isBundle: true,
      config: config,
      cmsClient: cmsClient,
      winnreAuth: winnreAuth,
      winnreNoAuth: winnreNoAuth,
      redux: redux,
      router: router
    }),
    bundleOffers = _useData.bundleOffers,
    isLoadingBundle = _useData.isLoadingBundle,
    searchInput = _useData.searchInput,
    handleChange = _useData.handleChange;
  var internalWebview = (_redux$webView$intern = redux === null || redux === void 0 || (_redux$webView = redux.webView) === null || _redux$webView === void 0 ? void 0 : _redux$webView.internalWebview) !== null && _redux$webView$intern !== void 0 ? _redux$webView$intern : redux === null || redux === void 0 ? void 0 : redux.internalWebview;
  var redeemNowButtonConfig = config === null || config === void 0 || (_config$deals = config.deals) === null || _config$deals === void 0 || (_config$deals = _config$deals.dealLayout) === null || _config$deals === void 0 ? void 0 : _config$deals.redeemNowButtonConfig;
  var isAuthenticated = (_redux$auth$isAuthent = redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.isAuthenticated) !== null && _redux$auth$isAuthent !== void 0 ? _redux$auth$isAuthent : redux === null || redux === void 0 ? void 0 : redux.isAuthenticated;
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var authActions = (redux === null || redux === void 0 ? void 0 : redux.authActions) || {};
  var openLoginModal = function openLoginModal() {
    if (dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal) {
      dispatch(authActions.openLoginModal());
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(internalWebview ? "mb-16" : "", " ").concat(config !== null && config !== void 0 && config.darkMode ? "bg-black" : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white")),
    children: [/*#__PURE__*/_jsx("div", {
      className: "\n                    ".concat(config === null || config === void 0 ? void 0 : config.bannerNegativeTopMarginClass, " w-full h-auto  "),
      children: (config === null || config === void 0 ? void 0 : config.header) && /*#__PURE__*/_jsx("div", {
        className: config === null || config === void 0 ? void 0 : config.header.headerClass
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "px-3 lg:pl-0 w-full lg:w-[95%] xl:w-[90%] lg:mx-auto py-5",
      children: [/*#__PURE__*/_jsx(Header, {
        searchValue: searchInput,
        onSearchChange: handleChange,
        isBundeOffers: true,
        internalWebview: internalWebview,
        config: config,
        redux: redux,
        router: router,
        winnreAuth: winnreAuth,
        appType: appType
      }), /*#__PURE__*/_jsx("div", {
        id: "zeroDeal",
        children: searchInput.length > 0 && (bundleOffers === null || bundleOffers === void 0 ? void 0 : bundleOffers.length) > 0 || (bundleOffers === null || bundleOffers === void 0 ? void 0 : bundleOffers.length) === 0 && !isLoadingBundle && isAuthenticated && /*#__PURE__*/_jsx(ZeroState, {
          type: "deals"
        })
      }), !isAuthenticated && (bundleOffers === null || bundleOffers === void 0 ? void 0 : bundleOffers.length) === 0 && /*#__PURE__*/_jsx("div", {
        className: "flex justify-center items-center h-[60vh]",
        children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, redeemNowButtonConfig), {}, {
          content: "Login to view Offer Details",
          onClick: "FUNC",
          onClickFunc: openLoginModal,
          className: redeemNowButtonConfig === null || redeemNowButtonConfig === void 0 ? void 0 : redeemNowButtonConfig.className,
          config: config,
          redux: {
            dispatch: dispatch,
            authActions: authActions,
            auth: redux === null || redux === void 0 ? void 0 : redux.auth
          },
          router: router
        }))
      }), /*#__PURE__*/_jsxs("div", {
        children: [isLoadingBundle && /*#__PURE__*/_jsx(SkeletonBundleDeals, {}), (bundleOffers === null || bundleOffers === void 0 ? void 0 : bundleOffers.length) > 0 && !isLoadingBundle && /*#__PURE__*/_jsx(BundleOffers, {
          bundleOffers: bundleOffers,
          config: config,
          redux: redux,
          router: router,
          cmsClient: cmsClient,
          winnreAuth: winnreAuth
        }), /*#__PURE__*/_jsx("p", {
          className: "flex mx-auto text-center items-center w-[75%] text-primary z-10 pb-6 leading-5 justify-center text-sm mt-12 ".concat(getFont((config === null || config === void 0 ? void 0 : config.name).toUpperCase()).body, " "),
          children: "*By clicking on Redeem Now, you authorize RELOY and partner brands to contact you via WhatsApp, SMS, phone, email etc. All brands have their respective terms and conditions and neither Reloy nor ".concat(config === null || config === void 0 ? void 0 : config.fullName, " will be responsible in case of any concerns. ")
        })]
      })]
    })]
  });
}
export default BundleDeals;